import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Observable, of } from 'rxjs';

import { Chip } from '@app/constants';

import { FacetsService } from '@app/data';

@Component({
  selector: 'app-chips',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './chips.component.html',
  styleUrls: ['./chips.component.less']
})
export class ChipsComponent {

	@Input() chips: Chip[] = [];

  constructor(
    private facet: FacetsService
  ) {}
}
